import {
  linkedin_repository,
} from '@/repositories';

import { LINKEDIN_ACCOUNT_STATUS_CONSTANTS } from '@/constants';

const state = () => ({
  unipile_credentials: null,
  waiting_for_unipile_response: false,
  is_linkedin_connected: false,
  account_infos: null,
});

const getters = {
  unipileCredentials: (state) => state.unipile_credentials,
  waitingForUnipileResponse: (state) => state.waiting_for_unipile_response,
  isLinkedinConnected: (state) => state.is_linkedin_connected,
  accountInfos: (state) => state.account_infos,
};

const actions = {
  async getUnipileCredentials({commit}, data) {
    commit('set_waiting_for_unipile_response', true);

    const [credentials] = await linkedin_repository.getUnipileCredentials(data);

    commit('set_waiting_for_unipile_response', false);

    commit('set_unipile_credentials', credentials || null);

    // eslint-disable-next-line vue/max-len
    const is_linkedin_connected = credentials?.status === LINKEDIN_ACCOUNT_STATUS_CONSTANTS.CONNECTED;

    commit('set_account_infos', credentials?.account_infos || null);

    commit('set_is_linkedin_connected', is_linkedin_connected);
  },
  async createAuthUrl({state}, data) {
    const type = state.unipile_credentials?.status === LINKEDIN_ACCOUNT_STATUS_CONSTANTS.DISCONNECTED ? 'reconnect' : 'create';

    const auth_url = await linkedin_repository.createAuthUrl({
      ...data,
      type,
    });

    return auth_url.url;
  },
  async disconnectToLinkedin(_, data) {
    const payload = data || {};
    const response = await linkedin_repository.disconnectToLinkedin(payload);

    const {
      user_disconnected_list,
    } = response;

    return user_disconnected_list;
  },
  async getUserProfile(_, input) {
    const user_profile = await linkedin_repository.getUserProfile(input);

    return user_profile;
  },

  async getMessages(_, input) {
    const response = await linkedin_repository.getMessages(input);

    return response?.user_message_list;
  },

  async getLinkedinContactMappings(_, input) {
    const response = await linkedin_repository.getLinkedinContactMappings(input);

    return response?.linkedin_contact_mapping_list;
  },

  async getLinkedinEvents(_, input) {
    const response = await linkedin_repository.getLinkedinEvents(input);

    return response?.linkedin_event_list;
  },

  async sendInvitation(_, { contact_id, input }) {
    const response = await linkedin_repository.sendInvitation(contact_id, input);

    return response;
  },

  async sendMessage(_, { contact_id, input }) {
    const response = await linkedin_repository.sendMessage(contact_id, input);

    return response;
  },
};

const mutations = {
  set_unipile_credentials(state, unipile_credentials) {
    state.unipile_credentials = unipile_credentials;
  },
  set_waiting_for_unipile_response(state, waiting_for_unipile_response) {
    state.waiting_for_unipile_response = waiting_for_unipile_response;
  },
  set_is_linkedin_connected(state, is_linkedin_connected) {
    state.is_linkedin_connected = is_linkedin_connected;
  },
  set_account_infos(state, account_infos) {
    state.account_infos = account_infos;
  },
  reset_state(state) {
    state.unipile_credentials = null;
    state.waiting_for_unipile_response = false;
    state.is_linkedin_connected = false;
    state.account_infos = null;
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
